/**
 * @generated SignedSource<<3b48fdac4bae95b74587690952b4d7ee>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FavoriteCell$data = {
  readonly id: string;
  readonly isFavourite: boolean | null | undefined;
  readonly name: string;
  readonly " $fragmentType": "FavoriteCell";
};
export type FavoriteCell$key = {
  readonly " $data"?: FavoriteCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"FavoriteCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "FavoriteCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "isFavourite"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "e573ead9d59ccd32501e19b601376a76";

export default node;
